export { OTPModal } from './OTPModal';
export type { OTPModalProps } from './OTPModal';


